module.exports = __webpack_public_path__ + "fontawesome-webfont.24c601e721ebd8279d38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.svg?v=4.6.3
// module id = 539
// module chunks = 2